import { Link } from 'react-router-dom';

const clusterCards = [
  { label: 'Тренинг для руководителей', href: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley', desc: 'Комплексная программа развития управленческих компетенций' },
  { label: 'Делегирование и постановка задач', href: '/menedzhment-i-liderstvo/delegirovanie-i-postanovka-zadach', desc: 'Как передавать ответственность и ставить задачи с измеримым результатом' },
  { label: 'Обратная связь и сложные разговоры', href: '/menedzhment-i-liderstvo/obratnaya-svyaz-i-slozhnye-razgovory', desc: 'Как давать обратную связь, которая меняет поведение сотрудника' },
  { label: 'Мотивация и управление командой', href: '/menedzhment-i-liderstvo/motivatsiya-i-upravlenie-komandoy', desc: 'Как понимать мотивацию сотрудников и создавать условия для вовлечённости' },
  { label: 'Управление конфликтами', href: '/menedzhment-i-liderstvo/trening-po-upravleniyu-konfliktami', desc: 'Как разбирать конфликты и переводить их в конструктивное решение' },
  { label: 'Управленческие переговоры', href: '/menedzhment-i-liderstvo/upravlencheskie-peregovory', desc: 'Как руководителю вести сложные переговоры с сотрудниками и руководством' },
  { label: 'Управление изменениями', href: '/menedzhment-i-liderstvo/upravlenie-izmeneniyami', desc: 'Как внедрять изменения и работать с сопротивлением команды' },
  { label: 'Развитие управленческих компетенций', href: '/menedzhment-i-liderstvo/razvitie-upravlencheskih-kompetenciy', desc: 'Системное развитие ключевых управленческих навыков руководителей' },
  { label: 'Наставничество и развитие сотрудников', href: '/menedzhment-i-liderstvo/nastavnichestvo-i-razvitie-sotrudnikov', desc: 'Как формировать кадровый резерв и развивать будущих руководителей' },
];

export default function ClusterNavigation() {
  return (
    <section className="py-12 md:py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center gap-2 text-sm text-gray-500 mb-6">
          <Link to="/menedzhment-i-liderstvo" className="text-teal-600 hover:text-teal-700 font-semibold transition-colors cursor-pointer">
            Менеджмент и лидерство
          </Link>
          <i className="ri-arrow-right-s-line text-xs"></i>
          <span className="text-gray-900 font-semibold">Тренинг по лидерству</span>
        </div>

        <h2 className="text-lg md:text-xl font-bold text-gray-900 mb-2">
          Лидерство — одно из направлений развития руководителей
        </h2>
        <p className="text-sm md:text-base text-gray-600 mb-8 max-w-3xl leading-relaxed">
          У компаний могут быть разные управленческие задачи, поэтому существуют отдельные программы. Выберите направление, которое актуально для вашей компании прямо сейчас.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {clusterCards.map((card) => (
            <div key={card.label} className="bg-white rounded-xl border border-gray-200 p-5 hover:border-teal-300 transition-colors">
              {card.href ? (
                <Link to={card.href} className="block cursor-pointer">
                  <h3 className="font-bold text-gray-900 text-sm mb-1.5 hover:text-teal-600 transition-colors">{card.label}</h3>
                  <p className="text-gray-500 text-xs leading-relaxed">{card.desc}</p>
                </Link>
              ) : (
                <>
                  <h3 className="font-bold text-gray-900 text-sm mb-1.5">{card.label}</h3>
                  <p className="text-gray-400 text-xs leading-relaxed">{card.desc}</p>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}